import {
  addBackLink,
  addHiddenTemplateRow,
  addSpacerRow,
  addTitleRow,
  applyColumnLayout,
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_11,
  HEADER_FONT_12,
  HEADER_ROW,
  hideColumnsAfter,
  hideRowsThrough,
  setCell,
  setValueDataRow,
  setupSheetView,
  THIN,
  THIN_BLACK,
} from "./detailSheetCommon";

const COL_START = 4;
const COL_END = 8;

function borderHoldingHeaderRow(ws, row) {
  ws.getCell(row, COL_START).border = THIN_BLACK;
  ws.getCell(row, 5).border = { top: THIN, bottom: THIN, right: THIN };
  ws.getCell(row, 6).border = THIN_BLACK;
  ws.getCell(row, 7).border = THIN_BLACK;
  ws.getCell(row, COL_END).border = THIN_BLACK;
}

function formatSharePct(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).trim();
  if (str.endsWith("%")) return str;
  const num = Number(value);
  if (Number.isNaN(num)) return str;
  return `${num.toFixed(2)}%`;
}

function formatYesNo(value) {
  if (value === true || String(value).toLowerCase() === "yes") return "Yes";
  if (value === false || String(value).toLowerCase() === "no") return "No";
  if (value === null || value === undefined || value === "") return "";
  return String(value);
}

export function buildHoldingSubsidiaryAssociateSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Holding,subsidiary or associate");
  applyColumnLayout(
    ws,
    {
      A: 9.1796875,
      B: 9.1796875,
      C: 9.1796875,
      D: 6.81640625,
      E: 35.26953125,
      F: 28,
      G: 19.7265625,
      H: 34.26953125,
      I: 9.1796875,
      J: 9.1796875,
      K: 9.1796875,
    },
    ["A", "B"]
  );
  hideColumnsAfter(ws, 11);
  setupSheetView(ws, { xSplit: 3, ySplit: 11, topLeftCell: "D12", zoomScale: 80 });
  hideRowsThrough(ws, 5);

  addBackLink(ws, COL_END);
  addTitleRow(
    ws,
    COL_START,
    COL_END,
    "Holding, Subsidiary and Associate Companies (including joint ventures)"
  );

  borderHoldingHeaderRow(ws, HEADER_ROW);
  ws.getRow(HEADER_ROW).height = 58;
  [
    { col: COL_START, label: "Sr.\nNo.", font: HEADER_FONT_12 },
    {
      col: 5,
      label: "Name of the holding / subsidiary/associate companies/joint ventures (A)",
      font: HEADER_FONT_12,
    },
    {
      col: 6,
      label: "Indicate whether holding/Subsidiary/Associate /Joint Venture",
      font: HEADER_FONT_12,
    },
    { col: 7, label: "% of shares held by listed entity", font: HEADER_FONT_11 },
    {
      col: COL_END,
      label:
        "Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/No)",
      font: HEADER_FONT_11,
    },
  ].forEach(({ col, label, font }) => {
    setCell(ws, HEADER_ROW, col, label, { font, bordered: false });
  });

  addHiddenTemplateRow(ws, COL_START, COL_END, { height: 46.5 });
  addSpacerRow(ws, COL_START, COL_END);

  const companies = sectionA?.holding?.associatedCompaniesAndCsr || [];
  const rows = companies.length ? companies : [];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setValueDataRow(ws, row, COL_START, COL_END, item, [
      { col: COL_START, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: 5, value: item?.name ?? "", align: "left" },
      { col: 6, value: item?.relationType ?? "", align: "left" },
      { col: 7, value: formatSharePct(item?.sharePercentage), align: "right" },
      { col: COL_END, value: formatYesNo(item?.participatesInBR), align: "center" },
    ]);
    ws.getRow(row).height = 30;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
